import * as yup from 'yup'

import { getStoreCredits } from 'src/deps'

const StoreCreditsSchema = props => Object.assign({}, getStoreCredits(props))
export const schema = props => {
  const StoreCreditsSchemaData = StoreCreditsSchema(props)
  return yup.object(StoreCreditsSchemaData)
}
